import React from "react";
import { Grid } from "@mui/material";
import { ClientLogo } from "./styles";
import Charts from "./components/Charts";
import LeaseEvents from "../LeaseEvent/List";
import { useSelector } from "react-redux";

const TmeHome = ({ isloading }) => {
  const homePageData = useSelector((state) => state.pages.homePageData);
  const { client, preTransactionCounts, transactionCounts } = homePageData;
  const selectedClientId = useSelector(state => state.clients.selectedClientId);

  return (
    <>
      <Grid container>
        <Grid item xs={6}></Grid>
        <Grid item xs={6}>
          {isloading ? null : (
            <ClientLogo
              src={client?.clientLogoPath}
              width="120"
              alt="Client Logo"
            />
          )}
        </Grid>
      </Grid>
      <Grid container sx={{ position: "relative", top: "-20px" }}>
        <Charts
          preTransactionCounts={preTransactionCounts}
          transactionCounts={transactionCounts}
          isLoading={isloading}
        />
      </Grid>
      <Grid container sx={{ marginTop: "40px" }}>
        <Grid item xs={12}>
          <LeaseEvents
            selectedClientId={selectedClientId}
            parent="homePage"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default TmeHome;
